module.exports = __webpack_public_path__ + "img/twotoplv.0edf4033.svg";